import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';

let $ = jQuery || window.jQuery;
let swup = initSwup();
let canNavigate = true;

$(() => {
  // initial page load
  loadPage();

  swup.on('contentReplaced', () => {
    updatePage();

    // need to reinit filter events in header after getting replaced
    updateSubsequentPage();

    // if homepage remove filters / show full grid of posts
    if (window.location.pathname === '/') {
      clearFilters();
    }
  });

  // clear extra animation classes after animation is complete
  swup.on('animationInDone', () => {
    $(document.documentElement).removeClass('previous next back');
  });

  swup.on('transitionStart', () => {
    canNavigate = false;
  });

  swup.on('transitionEnd', () => {
    let page = swup.cache.getCurrentPage();
    console.log(page);
    canNavigate = true;
  });

  $(window).scroll(function () {
    $('figure.hovered').removeClass('hovered');
  });

  $(window).resize(function () {
    loadPage(/* reload */ true);
  });
});

function initSwup() {
  let NOT_SELECTORS = `:not([data-no-swup])` + `:not([href*="/wp-admin"])`;

  let containers = document.querySelector('#wpadminbar')
    ? ['#primary', '#masthead', '#wpadminbar']
    : ['#primary', '#masthead'];

  return new Swup({
    containers,
    linkSelector:
      `a[href^="${window.location.origin}"]${NOT_SELECTORS}, ` +
      `a[href^="/"]${NOT_SELECTORS}`,
    // animationSelector: '.site-main', // disable page transitions
    cache: true,
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupPreloadPlugin(),
      new SwupScriptsPlugin(),
    ],
  });
}

function loadPage(reload) {
  // consistent global elements
  let $body = $(document.body);
  let $filters = $('.filters');
  let $menuDesc = $('.menu_desc');

  const initMobileOrDektopNav = () => {
    if (
      /Android|iPhone/i.test(navigator.userAgent) ||
      window.matchMedia('(max-width: 700px)').matches
    ) {
      // mobile menu
      const mobileFilterButton = document.querySelector(
        '.mobile-filter-button'
      );
      $(mobileFilterButton).on('click', function () {
        const shouldOpen = this.innerHTML === 'Filter +';
        this.innerHTML = shouldOpen ? 'Filter –' : 'Filter +';
        $(this).toggleClass('is-active', shouldOpen);
      });
      $('.mobile-filter-lists a').on('click', function () {
        mobileFilterButton.innerHTML = 'Filter +';
        $(mobileFilterButton).removeClass('is-active');
      });
    } else {
      // enable desktop mouse filter menu
      $body.on('click', (e) => {
        // prevent menu open if a link is clicked
        if (e.target.matches('a, button, a *, button *, body.single *')) {
          return;
        }

        let willOpen = $menuDesc.html() === 'Filter';

        if (willOpen) {
          $filters.css({ left: +e.pageX + 'px', top: +e.pageY + 'px' });
          $filters.addClass('show');
          $body.addClass('stop-scrolling').addClass('has-open-menu');
          $menuDesc.text('Close');
        } else {
          // close everything
          closeMenus();
        }
      });

      // follow mouse menu
      $body.on('mousemove', function (e) {
        $menuDesc.css({
          left: +e.pageX + 'px',
          top: +e.pageY + 'px',
        });
      });
    }
  };

  if (reload) {
    $('.mobile-filter-button').off('click');
    $body.off('click');
    initMobileOrDektopNav();
    return;
  }
  initMobileOrDektopNav();

  $('a, button')
    .on('mouseenter', function () {
      $menuDesc.removeClass('show');
    })
    .on('mouseleave', function () {
      $menuDesc.addClass('show');
    });

  $('.filters a').on('click', function () {
    // close mouse menu
    $filters.removeClass('show');
    // $menuDesc.text('Filter');
    $body.removeClass('stop-scrolling').removeClass('has-open-menu');
  });

  // open tags nav
  $('.open-tag-list').on('click', function () {
    $('body').addClass('has-open-menu');
    $('.header-info_close').removeClass('hide');
    $('.header-info').addClass('hide');
    $('.tag-list').removeClass('hide');
    $('.cat-list').addClass('hide');
    $('.project-list').addClass('hide');
  });

  // open project children nav
  $('.open-cat-list').on('click', function () {
    $('body').addClass('has-open-menu');
    $('.header-info_close').removeClass('hide');
    $('.header-info').addClass('hide');
    $('.tag-list').addClass('hide');
    $('.cat-list').removeClass('hide');
    $('.project-list').addClass('hide');
  });

  // open category children nav
  $('.open-project-list').on('click', function () {
    $('body').addClass('has-open-menu');
    $('.header-info_close').removeClass('hide');
    $('.header-info').addClass('hide');
    $('.tag-list').addClass('hide');
    $('.cat-list').addClass('hide');
    $('.project-list').removeClass('hide');
  });

  $('.menu-nav .list-item a, .grid .tag > a').on('click', filterPosts);

  // run update function once on initial load
  updatePage();

  let callout = document.querySelector('.AJR-callout');
  if (callout && !callout.classList.contains('hide')) {
    $(callout).click(function (e) {
      e.stopPropagation();
      $(this).addClass('hide');
      setTimeout(() => {
        enableColumnItemHover();
      }, 250);
    });
  } else {
    enableColumnItemHover();
    $(callout).addClass('hide');
  }
}

function updatePage() {
  closeMenus();

  // previous/next buttons
  $('#previous-post-button').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $thisCol = $('#post-navigation')
      .find(`[href="${window.location.href}"]`)
      .closest('.col');
    $prevCol = $thisCol.prevAll('.col:not(.hide):first');
    prevLink = $prevCol.find('a.post-thumbnail')[0]?.href;

    if (prevLink && canNavigate) {
      lastClickedPrevLink = prevLink;
      swup.loadPage({ url: prevLink });
    }
  });
  $('#next-post-button').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $thisCol = $('#post-navigation')
      .find(`[href="${window.location.href}"]`)
      .closest('.col');
    $nextCol = $thisCol.nextAll('.col:not(.hide):first');
    nextLink = $nextCol.find('a.post-thumbnail')[0]?.href;

    if (nextLink && canNavigate) {
      lastClickedNextLink = nextLink;
      swup.loadPage({ url: nextLink });
    }
  });

  $('#close-post-button').on('click', function (e) {
    if (document.body.dataset.back) {
      e.preventDefault();
      e.stopPropagation();
      swup.loadPage({ url: document.body.dataset.back });
    }
  });

  // follow mouse single post navs
  $('.post-button')
    .on('mousemove', function (e) {
      $('#page').css({
        '--left': e.pageX + 'px',
        '--top': e.pageY - window.scrollY + 'px',
      });
    })
    .on('mouseleave', function (e) {
      $('#page').removeAttr('style');
    });

  const [firstPath] = window.location.pathname.split('/').filter(Boolean);

  // check if on a category page & filter if we are...
  if (firstPath === 'tag' || firstPath === 'category') {
    togglePostCountEvents(true);
    filterFromArchivePage();
  } else {
    togglePostCountEvents(false);
  }
}

function updateSubsequentPage() {
  $('.menu-nav .list-item a').on('click', filterPosts);

  let $menuDesc = $('.menu_desc');

  // these elements get replaced so need to reinit only for these A tags
  $('.site-header a')
    .on('mouseenter', function () {
      $menuDesc.removeClass('show');
    })
    .on('mouseleave', function () {
      $menuDesc.addClass('show');
    });

  if (document.body.dataset.back && window.location.pathname === '/') {
    document.body.removeAttribute('data-back');
    $('.grid > .col').removeClass('offset');
  }
}

function togglePostCountEvents(enabled) {
  let $menuDesc = $('.menu_desc');

  let innerHTML;
  const postCountEnter = () => {
    $menuDesc.removeClass('show');
    innerHTML = $('#post-count').html();
    $('#post-count').html(`Back to All Images`);
  };
  const postCountLeave = () => {
    $menuDesc.addClass('show');
    $('#post-count').html(innerHTML);
  };
  if (enabled) {
    $('#post-count')
      .on('mouseenter', postCountEnter)
      .on('mouseleave', postCountLeave)
      .css({ cursor: 'pointer' });
  } else {
    $('#post-count')
      .off('mouseenter')
      .off('mouseleave')
      .css({ cursor: 'default' });
  }
}

function enableColumnItemHover() {
  let delay;
  $('.col figure')
    .on('mouseenter', function () {
      $(this).addClass('hovered');
    })
    .on('mousemove', function () {
      let $this = $(this);
      if (!delay) {
        delay = setTimeout(() => {
          $this.addClass('hovered');
          delay = undefined;
        }, 150);
      }
    })
    .on('mouseleave', function () {
      $(this).removeClass('hovered');
      if (delay) {
        clearTimeout(delay);
        delay = undefined;
      }
    });
}

function filterPosts(e) {
  // prevent swup from navigating, but still update URL
  e.preventDefault();
  e.stopPropagation();

  // set this = to navbar's tag (.menu-nav .tag) even if image tag (.tag a) is clicked
  let _this = this;
  if (!$(this).attr('class')) {
    _this = $(`.list-item a[href="${this.href}"]`)[0] || this;
  }

  let $posts = $('#post-navigation .post');
  $('.menu-nav .list-item a').removeClass('active');
  $('.grid > .col').removeClass('offset');

  if (window.location.href === _this.href) {
    // "nav" to home page
    window.history.replaceState({}, '', '/');
    togglePostCountEvents(false);

    $posts.parent().removeClass('hide');

    let count = $posts.length;
    $('#post-count').html(`All Images, ${count}`);
  } else {
    // update to tag/cat url
    window.history.replaceState({}, '', _this.href);
    togglePostCountEvents(true);

    $(_this).addClass('active');

    let slug = _this.title; // added slug as title attribute to posts

    // filter grid
    $posts.each((_, post) => {
      let $post = $(post);
      let isVisible =
        $post.hasClass(`tag-${slug}`) || $post.hasClass(`category-${slug}`);

      $post.parent().toggleClass('hide', !isVisible);
    });

    let count = $('#post-navigation .col:not(.hide) > .post').length;
    $('#post-count').html(`${_this.innerHTML}, ${count}`);

    // add history to data attribute for "close" button:
    document.body.dataset.back = window.location.href;
    // add offset class
    offsetArchiveGridColumns();
  }

  closeMenus();
}

function filterFromArchivePage() {
  let link = $(`.menu-nav .list-item a[href="${window.location.href}"]`)[0];
  let $posts = $('#post-navigation .post');

  $('.menu-nav .list-item a').removeClass('active');
  $(link).addClass('active');

  let slug = link.title; // added slug as title attribute to posts

  // filter grid
  $posts.each(function (_, post) {
    let $post = $(post);
    let isVisible =
      $post.hasClass(`tag-${slug}`) || $post.hasClass(`category-${slug}`);

    $post.parent().toggleClass('hide', !isVisible);
  });

  let count = $('#post-navigation .col:not(.hide) > .post').length;
  $('#post-count').html(`${link.innerHTML}, ${count}`);

  // add history to data attribute for "close" button:
  document.body.dataset.back = window.location.href;
  // add offset class
  offsetArchiveGridColumns();
}

function offsetArchiveGridColumns() {
  $('.grid > .col:visible').each((i, col) => {
    let [count, offset] = getColumnCountAndOffset();
    if ((i + 1) % count === offset) {
      $(col).addClass('offset');
    }
  });
}

function getColumnCountAndOffset() {
  if (window.matchMedia('(min-width: 960px)').matches) return [7, 5];
  if (window.matchMedia('(min-width: 700px)').matches) return [5, 4];
  return [3, 3];
}

function closeMenus() {
  $('body').removeClass('stop-scrolling').removeClass('has-open-menu');
  $('.menu_desc').text('Filter');
  $('.filters').removeClass('show');
  $('.header-info').removeClass('hide');
  $('.header-info_close').addClass('hide');
  $('.tag-list').addClass('hide');
  $('.cat-list').addClass('hide');
  $('.project-list').addClass('hide');
}

function clearFilters() {
  $('.menu-nav a.tag').removeClass('active');
  $('.grid .col').removeClass('hide');
}
